/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import withRouter from "../WithRouter";
//Packages
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "./services/auth"; //import auth
// Common
import FadeIn from "../common/FadeIn";
import ReturnButton from "../common/ReturnButton";

const ReportCardView = (props) => {
  const [reportCard, setReportCard] = useState({});
  const [GradingList, setGradingList] = useState([]);
  // Extract the ID
  const reportcardid = props.params.reportcardid;
  const preReportcardid = useRef(); //Reference the previou ID to ensure new get request if it changes.
  // Get the customer data and set it
  useEffect(async () => {
    preReportcardid.current = reportcardid; // Assign Refs Value to current load
    // Get the Class Data
    const reportCardRequest = await axios.get(`/api/admin/report_cards/cardview/${reportcardid}`, {
      withCredentials: true,
    });
    setGradingList(reportCardRequest.data.GradingList);
    return setReportCard(reportCardRequest.data);
  }, [reportcardid]); // Run useEffect when the id changes to get new data.

  return (
    <div className='ReportCardView'>
      {!isAuthenticated() && <Navigate to='/admin/' />}
      <FadeIn delay={250} duration={450}>
        <Container>
          <Row className='text-center'>
            <Col>
              <h3>Progress Report for {reportCard.DateIssued}</h3>
              <ReturnButton />
            </Col>
          </Row>
          <Row className='mt-4 mb-4 text-center shadow-element pt-3 pb-3'>
            <Col>
              {GradingList.map((item, index) => (
                <div key={index} className='mx-1 mt-3 p-2 shadow text-center border'>
                  <h3>{item}</h3>
                  {index === 0 && <span>{reportCard.Score_1}</span>}

                  {index === 1 && <span>{reportCard.Score_2}</span>}

                  {index === 2 && <span>{reportCard.Score_3}</span>}

                  {index === 3 && <span>{reportCard.Score_4}</span>}

                  {index === 4 && <span>{reportCard.Score_5}</span>}

                  {index === 5 && <span>{reportCard.Score_6}</span>}

                  {index === 6 && <span>{reportCard.Score_7}</span>}

                  {index === 7 && <span>{reportCard.Score_8}</span>}

                  {index === 8 && <span>{reportCard.Score_9}</span>}

                  {index === 9 && <span>{reportCard.Score_10}</span>}

                  {index === 10 && <span>{reportCard.Score_11}</span>}

                  {index === 11 && <span>{reportCard.Score_12}</span>}
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </FadeIn>
    </div>
  );
};

export default withRouter(ReportCardView);
